import { useInfiniteQuery, useQuery } from 'react-query'

import { getLowStockSummary } from 'utils/apis/lowStock'
import { POS_ONLINE_HEADER } from '@/utils/static'

// Dari POS: header modul POS + request latar belakang yang tidak boleh memunculkan
// modal no-internet / toast error (banner cukup disembunyikan bila gagal).
const POS_REQUEST_CONFIG = {
  ...POS_ONLINE_HEADER,
  skipErrorNotification: true,
  silentOffline: true,
}

// `outletId` (POS): BE menghitung per outlet (produk yang tampil di outlet, qty gudang outlet).
// Tanpa `outletId` (Finance): agregat semua gudang seperti sebelumnya.
export const useLowStockSummaryQuery = ({
  outletId,
  pos = false,
  enabled = true,
  refetchOnMount = true,
} = {}) =>
  useQuery(
    ['products', 'low-stock-summary', { outletId }],
    async () => {
      const {
        data: { data },
      } = await getLowStockSummary(
        outletId ? { outlet_id: outletId } : undefined,
        pos ? POS_REQUEST_CONFIG : undefined,
      )
      return data
    },
    {
      staleTime: 60_000,
      refetchOnMount,
      enabled,
    },
  )

// Satu halaman response memuat kedua kategori (almost_empty & empty) dengan `page` yang sama,
// jadi halaman berikutnya ada selama salah satu kategori belum habis. Cek per tab di komponen.
export const useInfiniteLowStockQuery = ({
  search,
  outletId,
  pos = false,
  initialData,
  enabled = true,
} = {}) =>
  useInfiniteQuery(
    ['products', 'low-stock-summary', 'infinite', { search, outletId }],
    async ({ pageParam = 1 }) => {
      const {
        data: { data },
      } = await getLowStockSummary(
        { page: pageParam, search: search || undefined, outlet_id: outletId || undefined },
        pos ? POS_REQUEST_CONFIG : undefined,
      )
      return data
    },
    {
      getNextPageParam: (lastPage) => {
        const currentPage = lastPage?.empty?.current_page || lastPage?.almost_empty?.current_page
        const lastPageNumber = Math.max(
          lastPage?.almost_empty?.last_page || 0,
          lastPage?.empty?.last_page || 0,
        )
        return currentPage && currentPage < lastPageNumber ? currentPage + 1 : undefined
      },
      initialData,
      staleTime: 60_000,
      // Refetch saat fokus akan mengulang semua halaman yang sudah di-scroll.
      refetchOnWindowFocus: false,
      enabled,
    },
  )
